import { render, staticRenderFns } from "./practica_en_revision.vue?vue&type=template&id=b8d2a946&"
import script from "./practica_en_revision.vue?vue&type=script&lang=js&"
export * from "./practica_en_revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports